import { CONFIG } from '../../core/config';
import { OrgTreeNodeType } from '../admin/organizations/org-tree-node-type';
import { ViewModel } from '../view-model';

export class HierarchyTreeNode implements ViewModel {
  public readonly friendlyTypeNameSingular: string = 'Hierarchy Tree Node';
  public readonly apiRoute: string = CONFIG.apiRoutes.dashboardHierarchyTree;

  public orgTreeNodeId: string;
  public name: string;
  public orgTreeNodeType: OrgTreeNodeType;
  public children: HierarchyTreeNode[] = [];

  public json(): any {
    return this;
  }

  loadFromJson(data: any) {
    this.orgTreeNodeId = data.orgTreeNodeId;
    this.name = data.name;
    this.orgTreeNodeType = data.orgTreeNodeType;
    if (data.children) {
      data.children.forEach(c => {
        const child = new HierarchyTreeNode();
        child.loadFromJson(c);
        this.children.push(child);
      });
    }
  }
}
